// Uniqueness (Uranus): a word with no repeated letter scores more.
import { ALIGNMENT_NUMBERS as N } from '../constants';
import { lettersOf } from '../shared/letters';
import type { AlignmentDef } from '../types';

export const uniqueness: AlignmentDef = {
  id: 'uniqueness',
  planet: 'uranus',
  name: 'Uniqueness',
  text: () => `Words with no repeated letter score +${N.uniquenessPercent}%.`,
  wordPercent: (c) => {
    const letters = lettersOf(c.word);
    return new Set(letters).size === letters.length ? N.uniquenessPercent : 0;
  },
};
